import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";

import { CardBase } from "~/components/timeLine/cardBase.jsx";
import { DienstTemplate } from "../../dayTemplate/dienstTemplate.jsx";

export const CardDiensten = ({ users, data, saveAndNext, prev }) => {
  const [diensten, setDiensten] = useState([]);
  useEffect(() => {
    setDiensten(data.roosters);
  }, [data.roosters, setDiensten]);

  const handleSave = () => {
    saveAndNext({ roosters: diensten });
  };

  return (
    <CardBase prev={prev} next={handleSave}>
      
      <DienstTemplate
        users={users}
        hasAutofill={true}
        value={diensten}
        onChange={setDiensten}
      />

      <p className="small" style={{ marginTop: 12 }}>
        {$t("Methodes om diensten te vullen:")}
      </p>
      <p className="small">
        <span className="bold label">{$t("Leeg")}</span>
        {$t("Laat de dienst leeg, handmatig invullen.")}
      </p>
      <p className="small">
        <span className="bold label">{$t("Auto")}</span>
        {$t(
          "Automatisch invullen, verdeel de leden zo goed mogelijk over de diensten."
        )}
      </p>
      <p className="small" style={{ marginBottom: 12 }}>
        <span className="bold label">{$t("Sociaal")}</span>
        {$t(
          "Vraag leden voor hun voorkeur, en verdeel de diensten zo goed mogelijk over de voorkeuren."
        )}
      </p>
    </CardBase>
  );
};
